<template>
  <div>
    <van-dialog v-model="dialogShow" title="Tip" :showConfirmButton="false">
      <div class="visit-dialog-content">
        <!-- 你最近更新过该门店的拜访信息，是否继续编辑? 你最近更新过该门店的ReOrder，是否继续编辑？ -->
        <div class="link-tip" v-if="pageType === 'Reorder' && currentVisitInfo.lastType === 1">{{ $t('shared.titleThree') }}</div>
        <div class="link-tip" v-if="pageType !== 'Reorder' && currentVisitInfo.lastType === 1">{{ $t('shared.titleFour') }}</div>
        <!-- 最近更新过该门店的拜访信息，仍要新增拜访? 最近更新过该门店的ReOrder，仍要新增ReOrder？ -->
        <div class="link-tip" v-if="pageType === 'Reorder' && currentVisitInfo.lastType === 2">{{ currentVisitInfo.lastCreateUserName }} {{ $t('shared.titleFive') }}</div>
        <div class="link-tip" v-if="pageType !== 'Reorder' && currentVisitInfo.lastType === 2">{{ currentVisitInfo.lastCreateUserName }} {{ $t('shared.titleSix') }}</div>
        <div class="dialog-btn">
          <!-- 继续编辑 创建新的门店拜访 创建新的ReOrder -->
          <van-button color="#307bff" class="xu-btn copy-notice" type="info" @click="handleOper('visitOper')">{{ currentVisitInfo.lastType === 1 ? $t('button.continueEditing') : currentVisitInfo.lastType !== 1 && pageType === 'Reorder' ? $t('button.createANewReOrder') : $t('button.createNewStoreVisit') }}</van-button>
          <!-- 创建新的门店拜访 创建新的ReOrder -->
          <van-button color="#307bff" v-if="currentVisitInfo.lastType === 1" class="xu-btn" plain type="info" @click="handleOper('newVisit')">{{ pageType === 'Reorder' ? $t('button.createANewReOrder') : $t('button.createNewStoreVisit') }}</van-button>
          <!-- 查看最近的拜访记录 查看最近的ReOrder -->
          <van-button color="#307bff" v-if="currentVisitInfo.lastType === 2" class="xu-btn" plain type="info" @click="handleOper('visitRecord')">{{ pageType === 'Reorder' ? $t('button.viewRecentReOrder') : $t('button.viewRecentVisitRecords') }}</van-button>
          <van-button color="#307bff" class="xu-btn" plain type="info" @click="dialogShow=false">{{ $t('button.close') }}</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  props: {
    currentVisitInfo: {
      type: Object,
      default: () => {}
    },
    customerId: {
      type: String,
      default: ''
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialogShow: false
    }
  },
  created () {
    this.dialogShow = false
  },
  activated () {
    this.dialogShow = false
  },
  methods: {
    handleOper (type) {
      this.dialogShow = false
      let createVisitUrl = ''
      let DetailVisitUrl = ''
      if (this.pageType === 'storeExpansion') {
        createVisitUrl = '/storeExpansion/visitSellIn'
        DetailVisitUrl = '/storeExpansion/visitSellInDetail'
      } else if (this.pageType === 'salesDistribution') {
        createVisitUrl = '/salesDistribution/sdVisit'
        DetailVisitUrl = '/salesDistribution/sdVisitDetail'
      } else if (this.pageType === 'storeMaintain') {
        createVisitUrl = '/storeMaintain/storeVisit'
        DetailVisitUrl = '/storeMaintain/storeVisitDetail'
      } else if (this.pageType === 'Reorder') {
        createVisitUrl = '/storeMaintain/reOrderVisit'
        DetailVisitUrl = '/storeMaintain/reOrderVisitDetail'
      }
      if (!createVisitUrl) return
      if (type === 'visitOper') {
        this.$router.push(`${createVisitUrl}?visitId=${this.currentVisitInfo.lastType === 1 ? this.currentVisitInfo.id : ''}&customerId=${this.customerId}`)
      } else if (type === 'newVisit') {
        this.$router.push(`${createVisitUrl}?customerId=${this.customerId}`)
      } else if (type === 'visitRecord') {
        this.$router.push(`${DetailVisitUrl}?visitId=${this.currentVisitInfo.id}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.visit-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 20px;
  font-size: 14px;
  .link-txt {
    width: 200px;
  }
  .link-tip {
    font-size: 14px;
    margin-top: 10px;
  }
  .dialog-btn {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    .xu-btn {
      width: 100%;
      margin-bottom: 10px;
    }
  }
}
</style>
